export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-2.64c5c440.svg";